export const MODULE_NAME = 'integrations/ga4'

export const EVENTS = {
  CONTACT: 'contact',
  RESTRICTED_RECOMENDED_CLICK: 'restricted_recomended_click',
  COTTAGE_PHONE_CLICK: 'ficha_phone_click',
  KEEP_SEARCHING: 'Ficha_ver-mas-alojamientos_click',
  HOLIDAYS_CLICK: 'Vacaciones_clic',
  RO_SUCCESS_BLOG_CLICK: 'ro-success-page_blog_clic',
  RO_CONTACT_CLICK: 'ro_contacto_clic',
  COTTAGE_VIEW_PRICES_LINK: 'cottage_view_prices_link',
  VIEW_PHONE: 'view_phone',
  CLICK_PHONE: 'click_phone',
  COTTAGE_CONVERSION_ALL: 'ficha_CRV-a-cualquier-solicitud',
  HOME_SIMPLE_BANNER_CLICK: 'home_simplebanner_clic',
  HOME_MEDIA_BANNER_CLICK: 'home_mediabanner_clic',
  HOME_FEATURED_DESTINATIONS_CLICK: 'home_featureddestinations_clic',
  HOME_IMAGE_BANNER_CLICK: 'home_imagebanner_clic',
  PRICES_GO_BACK: 'prices_go_back',
  PUBLISH_YOUR_PROPERTY_CLICK: 'publish_your_property_click',
  REGISTER_OWNER: 'register_owner',
  IMPROVE_YOUR_RESERVATIONS_HERO_CLICK:
    'improve_your_reservations_hero_click_{index}',
  IMPROVE_YOUR_RESERVATIONS_CTA_CLICK:
    'improve_your_reservations_cta_click_{index}',
  IMPROVE_YOUR_RESERVATIONS_ALERT_CLICK:
    'improve_your_reservations_alert_click_{index}',
  IMPROVE_YOUR_RESERVATIONS_FORM_SUBMIT:
    'improve_your_reservations_form_submit',
  B2B_ECOM_BASIC: 'b2b_ecom_basic',
  B2B_ECOM_SELECT_SERVICE: 'b2b_ecom_select_service',
  B2B_ECOM_LEGAL: 'b2b_ecom_legal',
  B2B_ECOM_PAYMENT_SUCCESS: 'b2b_ecom_payment_success',
}
